import { css } from "styled-components";

import { redundantCssFromKebab } from "./redundant-css";

export const hideRecaptcha: ReturnType<typeof css> = css`
    .grecaptcha-badge {
        ${redundantCssFromKebab("visibility", "hidden")}
    }
`;
